import {
  BplrtEquipment,
  BplrtSMP,
  SrgLines,
  SmrtTrainDisruption,
  TrakoDashboard,
} from "./components";
import { AuthorizationRoute } from "../auth/AuthorizationRoute";
import { bplrtFlag, stellarFlag } from "./componentsFlag";

const bplrtRoutes = [
  {
    flag: "BPLRT.SMP",
    path: "/bplrt/smp",
    element: <BplrtSMP />,
    wrapper: AuthorizationRoute,
  },
  {
    flag: "BPLRT.EQUIPMENT",
    path: "/bplrt/equipment",
    element: <BplrtEquipment />,
    wrapper: AuthorizationRoute,
  },
  {
    flag: "SMRT_SRG",
    path: "/smrt/train-service-status",
    element: <SrgLines />,
    wrapper: AuthorizationRoute,
  },
  {
    flag: "SMRT_TRAIN",
    path: "/smrt/train-disruption",
    element: <SmrtTrainDisruption />,
    wrapper: AuthorizationRoute,
  },
];

const stellarRoutes = [
  {
    flag: "SMRT.TRAKO",
    path: "/analytics",
    element: <TrakoDashboard />,
    wrapper: AuthorizationRoute,
  },
];

export const externalRoutes = [
  ...(bplrtFlag ? bplrtRoutes : []),
  ...(stellarFlag ? stellarRoutes : []),
];

export default externalRoutes;
